import React, { Dispatch, useCallback, useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { saveAs } from 'file-saver'


import { colors } from '../../../constants/colors'
import { ButtonCustom } from '../../../component/mui-custom/MuiCustom'
import { RouteImage } from '../../../assets/routeImage'
import moment from 'moment'
import useMediaQuery from '@mui/material/useMediaQuery';

// COMPONENT
import * as styled from '../style/main.style'
import Navbar from '../Navbar'
import Header from '../Header'
import TableRowCommon from '../../../component/table/TableRowCommon';
import TableCustom from '../../../component/table/tableCustom';
import InputTextField from '../../../component/input/inputTextField'
import SearchAutocompleteSelect from '../../../component/select/searchAutocompleteSelect'
import InputDatePicker from '../../../component/input/inputDatePicker'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { ProjectApi, getProject } from '../../../api/project/project.api';
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../../../component/loading/Loading'
import { debouncedApiCall } from '../../../utils/app.utils'
import { FiscalYearApi } from '../../../api/fiscal-year/fiscalyear.api'
import { swalError, swalSuccess } from '../../../component/notification/swal'
import { notificationSwal } from '../../../utils/notification.swal'
import { setLoading, unsetLoading } from '../../../store/slice/loading/loading.slice'
import Swal from 'sweetalert2'
import MenuDropdown from '../../../component/menu-dropdown/MenuDropdown'
import AutocompleteSelect from '../../../component/select/autoCompleteSelect'
import { setPageLimitStore, setPageStore } from '../../../store/slice/pagination/pagination.slice'
import UpdateIcon from '@mui/icons-material/Update';



const ProjectInformation: React.FC = () => {
    const pageLimitStore: number = useSelector((state: any) => state?.pagination?.pageLimit);
    const pageStore: number = useSelector((state: any) => state?.pagination?.page);

    const { t } = useTranslation();
    const dispatch = useDispatch()
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const navigate: NavigateFunction = useNavigate();
    const permission = useSelector((state: any) => state?.permission?.permission)

    const matches: boolean = useMediaQuery('(min-width:600px)');

    const [isFocused, setIsFocused] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(Number);
    const [endDate, setEndDate] = useState<string>("");
    const [search, setSearch] = useState<string>("");
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC")

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const [idFiscalYear, setIdFiscalYear] = useState<number>(Number);
    const [idStatus, setIdStatus] = useState<number>(Number);

    const [project, setProject] = useState<any[]>([]);
    const [projectStatus, setProjectStatus] = useState<any[]>([]);

    const handleGetProject = useCallback(async () => {
        dispatch(setLoading())
        let condition: getProject = {
            keyword: search,
            page: pageStore,
            limit: pageLimitStore,
        }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (idStatus) condition = { ...condition, idStatus: idStatus }
        if (endDate) condition = { ...condition, endDate: endDate }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }

        await ProjectApi.getProject(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setProject(res.data?.result?.items)
                    setTotalPage(res.data?.result?.meta?.totalItems)
                } else {
                    dispatch(unsetLoading())
                }
            })
            .catch(error => {
                console.log(error)
                dispatch(unsetLoading())
            })
    }, [pageStore, pageLimitStore, search, idFiscalYear, idStatus, endDate, sortBy, sortType])

    const handleDeleteProject = async (idProject: number) => {
        dispatch(setLoading())
        await ProjectApi.deleteProject(idProject)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                }
            })
            .catch(error => {
                console.log(error)
                dispatch(unsetLoading())
                swalError(notificationSwal.error)
            })
            .finally(() => handleGetProject())
    }

    const headCells = [
        {
            id: "is_extended", disablePadding: false, width: 30, align: 'center', label: ""
        },
        {
            id: "idProject", disablePadding: false, align: 'center', width: 60, label: 'ลำดับ'
        },
        {
            id: "projectName",
            disablePadding: false,
            align: "center",
            width: 350,
            sortable: true,
            label: "โครงการ"
        },
        {
            id: "idFiscalYear", disablePadding: false, align: "center", sortable: true, width: 120, label: "ปีงบประมาณ"

        },
        {
            id: "sumAllBudget", disablePadding: false, align: "center", width: 200, sortable: true, label: "งบประมาณ"

        },
        {
            id: "periodCount", disablePadding: false, align: "center", width: 120, sortable: true, label: "งวดงาน"

        },
        {
            id: "RESPONSIBLE_PERSON", disablePadding: false, align: "center", width: 200, label: "ผู้รับผิดชอบโครงการ"

        },
        {
            id: "STATUS_PUBLISH", disablePadding: false, align: "center", width: 160, label: "สถานะการเผยแพร่"
        },
        {
            id: "STATUS",
            class: matches ? true : false,
            disablePadding: false, align: "center",
            width: 270,
            label: "สถานะ"
        },
    ];

    const renderData = (objData: any, index: any) => {
        index = pageStore * pageLimitStore - pageLimitStore + index + 1
        const { projectName, idProject, is_extended, mainResponsibleName, periodCount, statusName, idFiscalYear, isPublic, sumAllBudget, idType } =
            objData;

        const objRenderData = {
            key: index,
            id: idProject,
            obj: objData,
            columns: [
                {
                    // option: "TEXT", align: "center", label: is_extended ? <UpdateIcon /> : ""
                    option: "TEXT", align: "center", label: +is_extended ? <Box pl={3} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <UpdateIcon sx={{ color: "#eb9615" }} />
                    </Box> : ""
                },
                { option: "TEXT", align: "center", label: index || '-' },
                {
                    option: "TEXT",
                    align: "left",
                    label: projectName || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: idFiscalYear || "-",
                },
                {
                    option: "PRICE",
                    align: "right",
                    label: sumAllBudget || 0,
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: `${periodCount} งวด` || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: mainResponsibleName || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: isPublic ?
                        <Typography className='text-primary' variant='subtitle1'>{"เผยแพร่โครงการแล้ว"}</Typography> :
                        <Typography sx={{ color: colors.lampang_button_secondary }} variant='subtitle1'>{'ยังไม่เผยแพร่โครงการ'}</Typography>,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches ? true : false,
                    width: 560,
                    component: (
                        <>
                            <div className='text-left h-full w-full flex flex-row gap-2'>
                                <span className='w-full scale-75'>
                                    <li className='list-item leading-[desired-line-height] text-base_disable'>
                                        {statusName}
                                    </li>
                                </span>
                                <span className='flex justify-center items-center gap-x-3'>
                                    {permission && permission?.find((list: any) => list?.code === "ProjectInformation.Read")?.permit === true && (
                                        <button
                                            onClick={() => navigate(`/auth/project-information/view/${idProject}`)}
                                        >
                                            <RemoveRedEyeOutlinedIcon
                                                className='text-base_disable cursor-pointer' />
                                        </button>
                                    )}
                                    {permission && permission?.find((list: any) => list?.code === "ProjectInformation.Edit")?.permit === true && (
                                        <button
                                            onClick={() => navigate(`/auth/project-information/update/${idProject}`, { state: { idTypes: idType } })}
                                        >
                                            <img src={RouteImage.editIcon} style={{ maxWidth: 24 }} alt='icons' />
                                        </button>
                                    )}
                                    {permission?.find((list: any) => list?.code === "ProjectInformation.Delete")?.permit === true && (
                                        <button
                                            onClick={() => {
                                                Swal.fire({
                                                    title: "คุณต้องการลบโครงการ?",
                                                    animation: true,
                                                    showCancelButton: true,
                                                    allowEnterKey: true,
                                                    confirmButtonColor: colors.themeMainColor,
                                                    cancelButtonColor: colors.danger,
                                                    cancelButtonText: t("BUTTON.CANCEL"),
                                                    showClass: {
                                                        popup: `
                                                      animate__animated
                                                      animate__fadeInUp
                                                      animate__faster
                                                    `
                                                    },
                                                    hideClass: {
                                                        popup: `
                                                      animate__animated
                                                      animate__fadeOutDown
                                                      animate__faster
                                                    `
                                                    },
                                                    confirmButtonText: "ลบโครงการ",
                                                }).then(async (result) => {
                                                    if (result.isConfirmed) {
                                                        await handleDeleteProject(idProject)
                                                        Swal.fire("บันทึกข้อมูลเรียบร้อย", "", "success");
                                                    } else {

                                                    }
                                                });

                                            }}
                                        >
                                            <img src={RouteImage.delete} style={{ maxWidth: 24 }} alt='icons' />
                                        </button>
                                    )}
                                </span>
                            </div>
                        </>
                    ),
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        debouncedApiCall({ searchItem: event.target.value, setItem: setSearch })
    }



    const handleGetProjectStatus = async () => {
        // let condition: any = {}
        await ProjectApi.getAllProjectStatus()
            .then(res => {
                if (res.status === 200) {
                    setProjectStatus(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const handleGetProjectFile = useCallback(async (format: 'pdf' | 'excel') => {
        dispatch(setLoading())
        let condition: getProject = {
            format: format
        }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        if (search) condition = { ...condition, keyword: search }
        if (idStatus) condition = { ...condition, idStatus: idStatus }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (endDate) condition = { ...condition, endDate: endDate }

        await ProjectApi.excelExport(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const data = res?.data
                    if (format === 'pdf') {
                        const blob = new Blob([data], { type: 'application/pdf' });
                        saveAs(blob, 'project-pdf-e-monitering');
                    } else if (format === 'excel') {
                        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        saveAs(blob, 'project-xlsx-e-monitering');
                    }
                }
            })
            .catch(error => console.log(error))
            .finally(() => dispatch(unsetLoading()))
    }, [search, idStatus, idFiscalYear, endDate])


    useEffect(() => {
        handleGetProjectStatus();
    }, [])

    useEffect(() => {
        handleGetProject()
    }, [handleGetProject])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <section className='w-full gap-3 flex items-start md:items-center flex-col md:flex-row justify-between'>
                        <span>
                            <Typography className='text-primary' variant='h4'>
                                {t("ข้อมูลโครงการ")}
                            </Typography>
                        </span>
                        {permission?.find((list: any) => list?.code === "ProjectInformation.Create")?.permit === true && (
                            <ButtonCustom
                                onClick={() => navigate('/auth/project-information/create')}
                                startIcon={<img src={RouteImage.plusButton} />}
                                sx={{
                                    width: "139px",
                                    border: `1px solid ${colors.lampang_primary}`,
                                    color: colors.lampang_primary,
                                    backgroundColor: colors.lampang_sub_primary,
                                    '&:hover': {
                                        backgroundColor: colors.lampang_sub_primary
                                    }
                                }}
                            >
                                {t("สร้างโครงการ")}
                            </ButtonCustom>
                        )}

                    </section>
                    <section className='w-full mt-8'>
                        <article className='grid grid-cols-12 gap-x-1 gap-y-2'>
                            <span className='col-span-12 lg:col-span-3 self-end'>
                                <InputTextField
                                    headingNormal
                                    onchange={handleChangeSearch}
                                    heading={t("ค้นหาตามชื่อโครงการ")}
                                    placeholder='ค้นหา...'
                                    onFocus={() => setIsFocused(true)}
                                    onblur={() => setIsFocused(false)}
                                />
                            </span>
                            <span className='col-span-12 lg:col-span-2 self-end'>
                                <InputDatePicker
                                    headingNormal
                                    inputName='startProject'
                                    inputHeight={42}
                                    dateFormat="DD/MM/YYYY"
                                    key={"END_DATE_PROJECT"}
                                    value={endDate}
                                    placeholder={t('ระบุวันที่')}
                                    onClear={() => setEndDate("")}
                                    onChange={(e: any) => {
                                        setEndDate(moment(e).format("YYYY-MM-DD"))
                                    }}
                                    allowClear
                                    heading={t("ถึงวันที่")}
                                />
                            </span>
                            <span className='col-span-12 lg:col-span-2 self-end'>
                                <SearchAutocompleteSelect
                                    headingNormal
                                    heading={t("ปีงบประมาณ")}
                                    labelId="label-fiscal-year"
                                    idKey="idFiscalYear"
                                    value={idFiscalYear}
                                    serverSearch={false}
                                    fetchOptions={(condition) => FiscalYearApi.getFiscalYear(condition)}
                                    getOptionLabel={(option) => String(option?.fiscalYear ?? '')}
                                    onChange={(id) => setIdFiscalYear(id)}
                                />
                            </span>
                            <span className='col-span-12 lg:col-span-4 flex justify-start items-end gap-x-1 gap-y-2 flex-wrap lg:flex-nowrap'>
                                <div className='w-full'>
                                    <AutocompleteSelect
                                        getOptionLabel={(option) => option?.projectStatusName || ""}
                                        headingNormal
                                        placeholder='ค้นหาสถานะ'
                                        heading={t("สถานะ")}
                                        // renderValue={() => idStatus === 0 ? "ทั้งหมด" : projectStatus?.find((list: any) => list?.idStatus === idStatus)?.projectStatusName}
                                        // label={t('')}
                                        // selectId="select-typeOfMissionGroup"
                                        value={projectStatus?.find((list: any) => list?.idStatus === idStatus)?.projectStatusName}
                                        labelId="label-status-all"
                                        onChange={(_, value: any) => {
                                            setIdStatus(value?.idStatus)
                                        }}
                                        // onchange={(event) => {
                                        //     const value = event.target.value
                                        //     value && setIdStatus(Number(value))
                                        // }}
                                        options={projectStatus || []}
                                    />
                                </div>
                                {/* <div>
                                    <ButtonContained
                                        startIcon={<SearchIcon />}
                                        sx={{ maxWidth: "83px", height: "42px" }}>
                                        <Typography variant='body1'>
                                            ค้นหา
                                        </Typography>
                                    </ButtonContained>
                                </div> */}
                            </span>
                            {permission?.find((list: any) => list?.code === "ProjectInformation.Exported")?.permit === true && (
                                <span className='col-span-12 lg:col-span-1 flex justify-end gap-1 overflow-hidden'>
                                    <span className='w-auto flex flex-col self-end gap-2'>
                                        <MenuDropdown
                                            headingNormal
                                            heading='ส่งออกเอกสาร'
                                            buttonName='ดาวน์โหลด'
                                            menuItems={[
                                                { id: 1, name: "pdf", onClick: () => handleGetProjectFile('pdf') },
                                                { id: 2, name: 'excel', onClick: () => handleGetProjectFile('excel') }
                                            ]}
                                        />
                                    </span>
                                </span>
                            )}
                        </article>
                    </section>

                    <section className='w-full mt-3' >
                        {project && (
                            <TableCustom
                                customScroll
                                page={pageStore}
                                pageLimit={pageLimitStore}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalPage}
                                rowsData={project && project?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => dispatch(setPageLimitStore(value))}
                                setPage={(value: number) => dispatch(setPageStore(value))}
                                tableMinWidth={1440}
                                tableFixedWidth
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>
        </styled.ContainerHome >
    )
}

export default ProjectInformation